import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ButtonAction from '../Button.js/SaveButton';
import { useTranslation } from 'react-i18next';
import { Alert, AlertTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import Iconify from '../iconify';


export default function NotificationWarnLocationDeviceModal({ 
    visible = false, 
    setVisible, 
    title = '',
    data = {}, 
}) {
    const { t } = useTranslation();

    const handleClose = () => {
        setVisible(!visible);
    }

    return (
        <>
            <Dialog open={visible} onClose={handleClose} aria-labelledby="draggable-dialog-title">
                <DialogTitle id="draggable-dialog-title">
                    {title}  
                </DialogTitle>
                <DialogContent>
                    <Alert severity="warning" style={{ marginBottom: '20px' }}>
                        {t('notification_warning_location_device.title')}
                        <p style={{margin: 0}}>
                            {t('notification_warning_location_device.content')} {data?.cabinet_nm} 
                            {t('notification_warning_location_device.content_cd')} {data?.cabinet_cd} {t('notification_warning_location_device.end_content')}</p>
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <ButtonAction
                        title={t('close')}
                        onClick={handleClose}
                        // variant="text"
                        type="cancel"
                    />
                </DialogActions>
            </Dialog>
        </>
    );
}
